import { createAction } from '@reduxjs/toolkit';

import type {
  RestoreCartProductPhoto,
  FetchCropPhotoFailedPayload,
  FetchCropPhotoPayload,
  CropEntity,
} from './crops.types';

const fetchCropPhoto = {
  fulfilled: createAction<FetchCropPhotoPayload>('crops/fetchCropPhoto/fulfilled'),
  rejected: createAction<FetchCropPhotoFailedPayload>('crops/fetchCropPhoto/rejected'),
};

const fetchCropFilterPhoto = {
  fulfilled: createAction<FetchCropPhotoPayload>('crops/fetchCropFilterPhoto/fulfilled'),
  rejected: createAction<FetchCropPhotoFailedPayload>('crops/fetchCropFilterPhoto/rejected'),
};

const restoreCartProductPhotoCrops = {
  pending: createAction<RestoreCartProductPhoto[]>('crops/restoreCartProductPhotoCrops/pending'),
  fulfilled: createAction<CropEntity[]>('crops/restoreCartProductPhotoCrops/fulfilled'),
};

export default {
  fetchCropPhoto,
  fetchCropFilterPhoto,
  restoreCartProductPhotoCrops,
};
